<div id="forms" class="page-layout simple fullwidth" fxLayout="column" style="background-color: white;">
    <div class="center">
        <div class="content-card" class="center " fxLayout="row wrap">
            <br>
            <div class="course-step-content p-20" fxFlex="100">
                <img style="width: 200px; text-align: center; display:block;
                margin:auto;" src="assets/logo_GO2.jpg">
                <div fxLayout="column" fxLayoutAlign="end center" style="width: 100%; padding-top: 5%;">
                    <mat-form-field appearance="outline" style="width: 30%;">
                        <mat-label>{{'LOGIN.FORM.INPUT.LANGSEL' | translate}}</mat-label>
                        <mat-select [(value)]="selectedLanguage" required>
                            <mat-option *ngFor="let lang of languages" (click)="setLanguage(lang.id)" [value]="lang.id">
                                {{'SELECTOR.'+lang.id | translate}}
                            </mat-option>
                        </mat-select>
                        <mat-icon matSuffix class="secondary-text">language</mat-icon>
                        <mat-error>idioma</mat-error>
                    </mat-form-field>
                </div>
                <ng-container *ngIf="showForm">
                    <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%; padding-bottom: 15%;">
                        <h3 style="font-weight: bolder;">{{'LOGIN.RESET.LABEL01' | translate}} {{email}} </h3>
                         <div class="" fxLayout="row" fxLayoutAlign="space-between start">
                          <div class="" fxLayout="column" fxLayoutAlign="start stretch" fxFlex="70">
                           <mat-form-field appearance="outline">
                             <mat-label>{{'LOGIN.RESET.LABEL02' | translate}}</mat-label>
                             <input [type]="hide ? 'password' : 'text'" matInput [(ngModel)]='firtsPassword' (blur)="verifyPassword1()" ng-keydown="verifyPassword1()" (keyup)="validarPassRegis($event)" [ngClass]="{'borderPassTrue':bloquearBtn, 'borderPassFalse': !bloquearBtn}">
                             <button mat-icon-button matSuffix (click)="mostrarPassword($event);hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                               <mat-icon>{{hide ? 'lock' : 'lock_open'}}</mat-icon>
                             </button>

                           </mat-form-field>
                          <mat-progress-bar mode="determinate" value="{{medirPassRegis}}" class="valorRegis mb-20"></mat-progress-bar>
                           <mat-form-field appearance="outline" >
                                   <mat-label>{{'LOGIN.RESET.LABEL03' | translate}}</mat-label>
                                   <input type="password" matInput [(ngModel)]='secondPassword' [disabled]="!passwordOkRegis" (blur)="verifyPassword2()" [ngClass]="{'borderPassTrue':bloquearBtn, 'borderPassFalse': !bloquearBtn}">
                                   <mat-icon matSuffix>vpn_key</mat-icon>
                            </mat-form-field>
                           </div>
                           <div class="modalReglas" fxFlex="40">
                         <div *ngFor="let reglas of regalasPassRegis" fxLayout="row" fxLayoutAlign="start center" style="margin-top:0px;">
                           {{'PERFILES.USUARIO.'+reglas.regla | translate}}
                           <mat-icon *ngIf="!reglas.estatus" class="iconletrasReglasFalse">highlight_off</mat-icon>
                           <mat-icon *ngIf="reglas.estatus" class="iconletrasReglasTrue">check_circle_outline</mat-icon>
                         </div>
                         </div>
                      </div>
                        <!--(click)="buscarCorreo()"-->
                        <button mat-raised-button color="warn" style="background-color: red;" [disabled]="bloquearBtn" (click)="changePassword()">{{'LOGIN.RESET.BTN' | translate}}</button>
                    </div>
                    <div *ngIf="showMessage" class="subtitle" fxLayoutAlign="center center"><a class="linkPage" style="color: #3366BB;" (click)="goPassword()">{{'LOGIN.FORM.LOGIN' | translate}}</a></div>
                </ng-container>
                <ng-container *ngIf="!showForm">
                    <div fxLayout="column" fxLayoutAlign="start center" style="width: 100%; padding-bottom: 15%;">
                        <h1 style="font-weight: bolder; color:red">{{'LOGIN.RESET.ERROR' | translate}}</h1>
                    </div>
                </ng-container>

            </div>
        </div>
    </div>
</div>
